import * as React from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "../misc/Button";
import { cn } from "../../utils/classMerger";
import { getPlatformIcon } from "../../utils/logo-getter";

interface ViewPostButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    postUrl: string;
    platform: string;
    isMobile?: boolean;
}

const ViewPostButton = React.forwardRef<HTMLAnchorElement, ViewPostButtonProps>(
    ({ postUrl, platform, isMobile = false, className, ...props }, ref) => (
        <Button
            variant="outline"
            size="sm"
            asChild
            className={cn("flex items-center justify-center", isMobile && "flex-1", className)}
        >
            <a
                ref={ref}
                href={postUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View Post"
                title="View Post"
                {...props}
            >
                {getPlatformIcon(platform) ?? <ExternalLink className="w-4 h-4" />}
                View Post
            </a>
        </Button>
    )
);
ViewPostButton.displayName = "ViewPostButton";

export { ViewPostButton };
